// extracted by mini-css-extract-plugin
module.exports = {"roomDetailWrapper":"v1_roomDetailWrapper__FY1KI"};